import Modal from 'react-bootstrap/Modal';
import React, { useContext, useState, useEffect, useRef, useCallback } from 'react';
import DataContext from '../context';
import { ApiService } from '../services/apiServices';
import Skeleton from "react-loading-skeleton"
import { toast } from "react-toastify";
const AddressListModal = () => {
    const contextValues = useContext(DataContext)
    const didMountRef = useRef(true)
    const [isLoader, setIsLoader] = useState(true);
    const [isLoaderProccess, setIsLoaderProccess] = useState(false);
    const [defaultAddress, setDefaultAddress] = useState(0);

    const getUserAddressData = useCallback(() => {
        ApiService.fetchData('get-user-address').then((res) => {
            if (res.status === 'success') {
                setDefaultAddress(res.rowDefaultAddress?.ua_id)
                contextValues.setAddressList(res.resUserAddress)
            } else if (res.status === 'session_expired') {
                localStorage.removeItem('USER_TOKEN');
                window.location.href = '/';
            }
            setIsLoader(false)
        });
    }, []);

    useEffect(() => {
        if (didMountRef.current) {
            if (localStorage.getItem("USER_TOKEN")) {
                getUserAddressData()
            }
        }
        didMountRef.current = false
    }, [getUserAddressData]);

    const onClose = () => {
        contextValues.setToggleAddressListModal(!contextValues.toggleAddressListModal)
    }

    const setDefaultId = (addressId) => {
        setDefaultAddress(addressId)
    }

    const setAddress = () => {
        if (defaultAddress > 0) {
            const dataString = {
                ua_id: defaultAddress,
            };
            setIsLoaderProccess(true)
            ApiService.postData("chooseAddressnew", dataString).then((res) => {
                if (res.status === 'success') {
                    localStorage.setItem('SELECTED_ADDRESS', JSON.stringify(res.rowAddressDefault));
                    contextValues.setSelectedAddress(res.rowAddressDefault)
                    onClose()
                } else if (res.status === 'session_expired') {
                    localStorage.removeItem('USER_TOKEN');
                    window.location.href = '/';
                } else {
                    if (res.status === 'serviceable_error') {
                        setIsLoaderProccess(false)
                        onClose()
                        setTimeout(() => {
                            contextValues.setToggleChangeDeliveryModal(true)
                        }, 200);
                    } else {
                        setIsLoaderProccess(false)
                        toast.error(res.message);
                    }
                }
                setIsLoaderProccess(false)
            });
        } else {
            toast.error('Internal Error, Please try later');
            return;
        }
    }

    const addressModal = () => {
        contextValues.setToggleAddressListModal(!contextValues.toggleAddressListModal)
        contextValues.setToggleAddressModal(!contextValues.toggleAddressModal)
    }

    return (
        <>
            <Modal className="addressModal bottom" show={contextValues.toggleAddressListModal} onHide={(e) => { onClose() }}>
                <div className='addressModalContent'>
                    <button type="button" className="addressModalclose" onClick={() => { onClose() }}><i className="ri-close-line"></i></button>
                    {isLoader ?
                        <div className='addressModalContentInner'>
                            <div className='mb-20'>
                                <h5><Skeleton width={150} height={20}></Skeleton></h5>
                                <p className='mb-0 tx-14 tx-gray'><Skeleton width={250} height={15}></Skeleton></p>
                            </div>
                            <div className='mb-20'>
                                <button type='button' className='btn btn-outline-primary  btn-md mt-2'><Skeleton width={150} height={20}></Skeleton></button>
                            </div>
                            <div className='savedaddresslist'>
                                <ul>
                                    <li>
                                        <div className='savedaddresslistDetails'>
                                            <h6 className='mb-1'><Skeleton width={80} height={15}></Skeleton></h6>
                                            <p className='tx-12 mb-0 tx-gray'><Skeleton width={300} height={15}></Skeleton></p>
                                        </div>
                                    </li>
                                    <li>
                                        <div className='savedaddresslistDetails'>
                                            <h6 className='mb-1'><Skeleton width={100} height={15}></Skeleton></h6>
                                            <p className='tx-12 mb-0 tx-gray'><Skeleton width={300} height={15}></Skeleton></p>
                                        </div>
                                    </li>
                                    <li>
                                        <div className='savedaddresslistDetails'>
                                            <h6 className='mb-1'><Skeleton width={100} height={15}></Skeleton></h6>
                                            <p className='tx-12 mb-0 tx-gray'><Skeleton width={300} height={15}></Skeleton></p>
                                        </div>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        :
                        <div className='addressModalContentInner'>
                            <div className='mb-20'>
                                <h5>Saved addresses</h5>
                                <p className='mb-0 tx-14 tx-gray'>choose saved address for faster checkout</p>
                            </div>
                            <div className='mb-20'>
                                <button
                                    className="btn btn-outline-primary  btn-md mt-2"
                                    onClick={(e) => {
                                        addressModal();
                                    }}
                                >
                                    Add New Address <i className="ri-add-circle-line"></i>
                                </button>

                            </div>
                            <div className='savedaddresslist'>
                                <ul>
                                    {contextValues.addressList && contextValues.addressList.map((value, index) => {
                                        return (
                                            <li key={index} onClick={() => setDefaultId(value.ua_id)}>
                                                <div><input type='radio' name="ua_default_address" checked={Number(defaultAddress) === Number(value.ua_id) ? true : false}></input></div>
                                                <div className='savedaddresslistDetails'>
                                                    <h6 className='mb-1'>{value.ua_address_type === "Other" ? value.ua_address_type_other : value.ua_address_type}</h6>
                                                    <p className='tx-12 mb-0 tx-gray'>{[value.ua_house_no, value.ua_floor, value.ua_complete_address, value.ua_area, value.ua_city_name, value.ua_state_name, value.ua_pincode, value.ua_how_to_reach]
                                                            .filter(Boolean)
                                                            .join(", ")} </p>
                                                </div>
                                            </li>
                                        )
                                    })}

                                </ul>
                            </div>
                            <button className='btn btn-primary btn-lg btn-full' type='button' onClick={() => setAddress()} disabled={isLoaderProccess}>{isLoaderProccess ? <img src="/img/loder01.gif" alt="Loading..." width="90" height="15" /> : 'Continue'} </button>
                        </div>
                    }
                </div>
            </Modal>
        </>)
}
export default AddressListModal